import { isServer } from 'src/libs/helper'

import { useCompanyStorage } from './useCompanyStorage'
import { useProfileStorage } from './useProfileStorage'

const GAId = process.env.GoogleAnalyticsId

export const useGA = () => {
  const { loadProfileFromLocalStorage } = useProfileStorage()
  const { loadCompanyFromLocalStorage } = useCompanyStorage()

  const sendPageView = (path: string) => {
    if (isServer) {
      return
    }
    const config: { [key: string]: string | number } = {
      page_path: path,
    }

    const profile = loadProfileFromLocalStorage()
    if (profile) {
      config.user_id = profile.profileId
      config.user_role_name = profile.roleName
    }

    const company = loadCompanyFromLocalStorage()
    if (company) {
      config.company_id = company.companyId
      config.company_name = company.companyName
    }

    // @ts-ignore
    window.gtag('config', GAId, config)
  }

  const sendEvent = (
    eventName: string,
    eventParameters?: Record<string, string | number | boolean>
  ) => {
    if (!GAId || isServer) {
      return
    }
    if (eventParameters) {
      window.gtag('event', eventName, eventParameters)
    }
    window.gtag('event', eventName)
  }

  return { sendPageView, sendEvent }
}
